import { render, staticRenderFns } from "./NewAddressBookEntry.vue?vue&type=template&id=7992286a&scoped=true&"
import script from "./NewAddressBookEntry.vue?vue&type=script&lang=js&"
export * from "./NewAddressBookEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7992286a",
  null
  
)

export default component.exports